// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { Button } from "antd";
// import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../../components/Elements/Tables/Tables";
// import SortData from "../../../../../components/Elements/SortData.js/SortData";
// import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
// import { ReactComponent as DownloadIcon } from "../../../../../assets/svgs/download-icon.svg";
// import FilterReport from "../DailogBoxes/FilterReport";
// import { Badge } from "../../../../../components/Elements/TextStyles/Badge";
// import ViewReport from "../DailogBoxes/ViewReport";
// // Memoized table headers to avoid re-renders
// const ReportTable = () => {
//   const [tableData, setTableData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortBy, setSortBy] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [generateReport, setGenerateReport] = useState(false);
//   // Rename state
//   const [viewReportOpen, setViewReportOpen] = useState(false);

//   // Keep the component name as is

//   const surveyHeader = useMemo(() => [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Name", key: "name" },
//     { label: "Requested Date", key: "requested_date" },
//     { label: "Status", key: "status" },
//     { label: "Action", key: "action" },
//   ]);

//   let static_data = [
//     {
//       serial: 1,
//       name: "BRSR Report",
//       requested_date: "10/1/2025",
//       status: "In Process",
//     },
//     {
//       serial: 2,
//       name: "ESG Report",
//       requested_date: "10/6/2025",
//       status: "Completed",
//     },
//     {
//       serial: 3,
//       name: "Social Report",
//       requested_date: "15/6/2025",
//       status: "Completed",
//     },
//     {
//       serial: 4,
//       name: "Governance Report",
//       requested_date: "04/3/2025",
//       status: "Rejected",
//     },
//     {
//       serial: 5,
//       name: "Offsetgo ESG Report",
//       requested_date: "06/5/2025",
//       status: "In Process",
//     },
//   ];

//   // Function to get status button styles
//   const getStatusStyles = (status) => {
//     switch (status) {
//       case "In Process":
//         return {
//           backgroundColor: "#45827659", // Light green background
//           color: "#000000", // Dark green text
//           border: "1px solid #06513D", // Dark green border
//         };
//       case "Completed":
//         return {
//           backgroundColor: "#E8C45859", // Light yellow background
//           color: "#000000", // Dark yellow/orange text
//           border: "1px solid #E8C458", // Dark yellow/orange border
//         };
//       case "Rejected":
//         return {
//           backgroundColor: "#6AA4F759", // Light red background
//           color: "#000000", // Dark red text
//           border: "1px solid #6AA4F7", // Dark red border
//         };
//       default:
//         return {
//           backgroundColor: "#F3F4F6", // Light gray background
//           color: "#374151", // Dark gray text
//           border: "1px solid #374151", // Dark gray border
//         };
//     }
//   };

//   const handleFilterReport = useCallback(() => {
//     setGenerateReport(!generateReport);
//   }, [generateReport]);

//   // Search functionality
//   const handleSearch = useCallback((searchTerm) => {
//     setSearchTerm(searchTerm.toLowerCase());
//   }, []);

//   // Sorting functionality
//   const handleSort = useCallback(
//     (key, order) => {
//       setSortBy(key);
//       setSortOrder(order);
//       setTableData((prevData) => SortData({ data: prevData, key, order }));
//     },
//     [setTableData],
//   );

//   // Memoized filtered data
//   const filteredData = useMemo(() => {
//     if (!searchTerm) return tableData;
//     return tableData.filter((item) =>
//       surveyHeader.some((header) => {
//         if (header.key === "action") return false;
//         return String(item[header.key]).toLowerCase().includes(searchTerm);
//       }),
//     );
//   }, [tableData, searchTerm]);

//   const handleViewReport = useCallback(() => {
//     setViewReportOpen((prev) => !prev);
//   }, []);

//   useEffect(() => {
//     // const data = static_data.map((item, index) => ({
//     //   key: item.serial,
//     //   serial: item.serial,
//     //   name: item.name,
//     //   requested_date: item.requested_date,
//     //   status: (
//     //     <button
//     //       className="w-[100px] h-[28px] rounded-lg text-xs font-medium flex items-center justify-center"
//     //       style={getStatusStyles(item.status)}
//     //     >
//     //       {item.status}
//     //     </button>
//     //   ),
//     //   action: (
//     //     <div className="flex gap-3">
//     //       <EyeIcon style={{ fontSize: "18px", cursor: "pointer" }} />
//     //       <DownloadIcon style={{ fontSize: "18px", cursor: "pointer" }} />
//     //     </div>
//     //   ),
//     // }));
//     const data = static_data.map((item, index) => ({
//       key: item.serial,
//       serial: <div className="text-center">{item.serial}</div>,
//       name: <div className="text-center">{item.name}</div>,
//       requested_date: <div className="text-center">{item.requested_date}</div>,
//       status: (
//         <div className="flex justify-center">
//           <button
//             className="w-[100px] h-[28px] rounded-lg text-xs font-medium flex items-center justify-center"
//             style={getStatusStyles(item.status)}
//           >
//             {item.status}
//           </button>
//         </div>
//       ),
//       action: (
//         <div className="flex justify-center gap-3">
//           <EyeIcon
//             style={{ fontSize: "18px", cursor: "pointer" }}
//             onClick={handleViewReport}
//           />
//           <DownloadIcon style={{ fontSize: "18px", cursor: "pointer" }} />
//         </div>
//       ),
//     }));

//     setTableData(data);
//   }, []);

//   return (
//     <div
//       style={{
//         border: "1px solid #3BA2B959",
//         borderRadius: "10px",
//         marginTop: "15px",
//         backgroundColor: "white",
//       }}
//     >
//       {/* Header Section */}
//       <div className="flex justify-between mx-8 mt-4 font-medium">
//         <div className="flex gap-16">
//           <p className="text-[#06513D] text-base pt-2">Reports</p>
//           <SearchBar width="300px" onSearch={handleSearch} />
//         </div>
//         <div>
//           <Button
//             style={{
//               background: "#06513D",
//               height: "50px",
//               width: "150px",
//               borderRadius: "10px",
//               marginBottom: "15px",
//               color: "white",
//             }}
//             onClick={handleFilterReport}
//           >
//             Filter
//           </Button>
//         </div>
//       </div>

//       {generateReport ? (
//         <FilterReport
//           onOpen={generateReport}
//           onClose={() => setGenerateReport(false)}
//         />
//       ) : (
//         <></>
//       )}
//       {viewReportOpen && (
//         <ViewReport
//           onOpen={viewReportOpen}
//           onClose={() => setViewReportOpen(false)}
//         />
//       )}
//       {/* Table Section */}
//       <Tables
//         data={filteredData}
//         headers={surveyHeader}
//         pageSize={7}
//         sortBy={sortBy}
//         sortOrder={sortOrder}
//         onSort={handleSort}
//       />
//     </div>
//   );
// };

// export default React.memo(ReportTable);

// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { Button } from "antd";
// import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../../components/Elements/Tables/Tables";
// import SortData from "../../../../../components/Elements/SortData.js/SortData";
// import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
// import FilterReport from "../DailogBoxes/FilterReport";
// import ViewReport from "../DailogBoxes/ViewReport";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { useLocation } from "react-router-dom";

// const ReportTable = () => {
//   const [tableData, setTableData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortBy, setSortBy] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [generateReport, setGenerateReport] = useState(false);
//   const [viewReportOpen, setViewReportOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [selectedReport, setSelectedReport] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize] = useState(10);
//   const [totalRecords, setTotalRecords] = useState(0);

//   const location = useLocation();
//   const { projectName, projectId } = location.state || {};

//   const surveyHeader = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Name", key: "name" },
//       { label: "Requested Date", key: "requested_date" },
//       { label: "Status", key: "status" },
//       { label: "Action", key: "action" },
//     ],
//     [],
//   );

//   const STATUS_DISPLAY = {
//     in_process: "In Process",
//     completed: "Completed",
//     rejected: "Rejected",
//   };

//   const getStatusStyles = (status) => {
//     switch (status) {
//       case "in_process":
//         return {
//           backgroundColor: "#45827659",
//           color: "#000000",
//           border: "1px solid #06513D",
//         };
//       case "completed":
//         return {
//           backgroundColor: "#E8C45859",
//           color: "#000000",
//           border: "1px solid #E8C458",
//         };
//       case "rejected":
//         return {
//           backgroundColor: "#6AA4F759",
//           color: "#000000",
//           border: "1px solid #6AA4F7",
//         };
//       default:
//         return {
//           backgroundColor: "#F3F4F6",
//           color: "#374151",
//           border: "1px solid #374151",
//         };
//     }
//   };

//   const handleSearch = useCallback((value) => {
//     setSearchTerm(value);
//     setCurrentPage(1); // reset page on search
//   }, []);

//   const handleSort = useCallback((key, order) => {
//     setSortBy(key);
//     setSortOrder(order);
//     setTableData((prevData) => SortData({ data: prevData, key, order }));
//   }, []);

//   const handleViewReport = useCallback((item) => {
//     setSelectedReport(item);
//     setViewReportOpen(true);
//   }, []);

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}-${String(
//       date.getMonth() + 1,
//     ).padStart(2, "0")}-${date.getFullYear()}`;
//   };

//   const fetchReports = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_REPORTS(currentPage, pageSize, searchTerm),
//       });

//       const pagination = response.pagination;
//       setTotalRecords(pagination.totalRecords);
//       setCurrentPage(pagination.page);

//       const data = response.data.map((item, index) => ({
//         key: item._id,
//         serial: (
//           <div className="text-center">
//             {(currentPage - 1) * pageSize + index + 1}
//           </div>
//         ),
//         name: <div className="text-center">{item.report?.name || "N/A"}</div>,
//         requested_date: (
//           <div className="text-center">{formatDate(item.requested_on)}</div>
//         ),
//         status: (
//           <div className="flex justify-center">
//             <button
//               className="w-[100px] h-[28px] rounded-lg text-xs font-medium"
//               style={getStatusStyles(item.status)}
//             >
//               {STATUS_DISPLAY[item.status] || item.status}
//             </button>
//           </div>
//         ),
//         action: (
//           <div className="flex justify-center gap-3">
//             <EyeIcon
//               style={{ cursor: "pointer" }}
//               onClick={() => handleViewReport(item)}
//             />
//           </div>
//         ),
//       }));

//       setTableData(data);
//     } catch (error) {
//       console.error("Failed to fetch reports:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, pageSize, searchTerm]);

//   useEffect(() => {
//     fetchReports();
//   }, [fetchReports]);

//   return (
//     <div
//       style={{
//         border: "1px solid #3BA2B959",
//         borderRadius: "10px",
//         marginTop: "15px",
//         backgroundColor: "white",
//       }}
//     >
//       <div className="flex justify-between mx-8 mt-4 font-medium">
//         <div className="flex gap-16">
//           <p className="text-[#06513D] text-base pt-2">Reports</p>
//           <SearchBar width="300px" onSearch={handleSearch} />
//         </div>
//         <div>
//           <Button
//             style={{
//               background: "#06513D",
//               height: "50px",
//               width: "150px",
//               borderRadius: "10px",
//               marginBottom: "15px",
//               color: "white",
//             }}
//             onClick={() => setGenerateReport(true)}
//           >
//             Filter
//           </Button>
//         </div>
//       </div>

//       {generateReport && (
//         <FilterReport
//           onOpen={generateReport}
//           onClose={() => setGenerateReport(false)}
//           refreshTable={fetchReports}
//         />
//       )}

//       {viewReportOpen && (
//         <ViewReport
//           onOpen={viewReportOpen}
//           onClose={() => setViewReportOpen(false)}
//           reportData={selectedReport}
//           reportId={selectedReport?._id}
//         />
//       )}

//       <Tables
//         data={tableData}
//         headers={surveyHeader}
//         currentPage={currentPage}
//         pageSize={pageSize}
//         totalRecords={totalRecords}
//         onPageChange={(page) => setCurrentPage(page)}
//         sortBy={sortBy}
//         sortOrder={sortOrder}
//         onSort={handleSort}
//         loading={loading}
//       />
//     </div>
//   );
// };

// export default React.memo(ReportTable);

// import React, { useEffect, useState, useCallback, useMemo } from "react";
// import { Button } from "antd";
// import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
// import { Tables } from "../../../../../components/Elements/Tables/Tables";
// import SortData from "../../../../../components/Elements/SortData.js/SortData";
// import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
// import FilterReport from "../DailogBoxes/FilterReport";
// import ViewReport from "../DailogBoxes/ViewReport";
// import { getApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { useLocation } from "react-router-dom";

// const ReportTable = () => {
//   const [tableData, setTableData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [sortBy, setSortBy] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [generateReport, setGenerateReport] = useState(false);
//   const [viewReportOpen, setViewReportOpen] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [selectedReport, setSelectedReport] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize] = useState(10);
//   const [totalRecords, setTotalRecords] = useState(0);

//   const surveyHeader = useMemo(
//     () => [
//       { label: "Sr. No.", key: "serial" },
//       { label: "Name", key: "name" },
//       { label: "Requested Date", key: "requested_date" },
//       { label: "Status", key: "status" },
//       { label: "Action", key: "action" },
//     ],
//     []
//   );

//   const STATUS_DISPLAY = {
//     in_process: "In Process",
//     completed: "Completed",
//     rejected: "Rejected",
//   };

//   const getStatusStyles = (status) => {
//     switch (status) {
//       case "in_process":
//         return {
//           backgroundColor: "#45827659",
//           color: "#000000",
//           border: "1px solid #06513D",
//         };
//       case "completed":
//         return {
//           backgroundColor: "#E8C45859",
//           color: "#000000",
//           border: "1px solid #E8C458",
//         };
//       case "rejected":
//         return {
//           backgroundColor: "#6AA4F759",
//           color: "#000000",
//           border: "1px solid #6AA4F7",
//         };
//       default:
//         return {
//           backgroundColor: "#F3F4F6",
//           color: "#374151",
//           border: "1px solid #374151",
//         };
//     }
//   };

//   const handleSearch = useCallback((value) => {
//     setSearchTerm(value);
//     setCurrentPage(1); // Reset to first page on search
//   }, []);

//   const handleSort = useCallback((key, order) => {
//     setSortBy(key);
//     setSortOrder(order);
//     setTableData((prevData) => SortData({ data: prevData, key, order }));
//   }, []);

//   const handleViewReport = useCallback((item) => {
//     setSelectedReport(item);
//     setViewReportOpen(true);
//   }, []);

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return `${String(date.getDate()).padStart(2, "0")}-${String(
//       date.getMonth() + 1
//     ).padStart(2, "0")}-${date.getFullYear()}`;
//   };

//   const fetchReports = useCallback(async () => {
//     setLoading(true);
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_REPORTS(currentPage, pageSize, searchTerm),
//       });

//       console.log("API Response:", response);

//       // Check if response has the expected structure
//       if (response?.success && response?.data) {
//         // Extract pagination info
//         const pagination = response.pagination;
//         if (pagination) {
//           setTotalRecords(pagination.totalRecords || 0);
//           setCurrentPage(pagination.page || 1);
//         }

//         // Map the data
//         const data = response.data.map((item, index) => ({
//           key: item._id,
//           serial: (
//             <div className="text-center">
//               {(currentPage - 1) * pageSize + index + 1}
//             </div>
//           ),
//           name: (
//             <div className="text-center">
//               {item.report_id?.name || item.report?.name || "N/A"}
//             </div>
//           ),
//           requested_date: (
//             <div className="text-center">{formatDate(item.requested_on)}</div>
//           ),
//           status: (
//             <div className="flex justify-center">
//               <button
//                 className="w-[100px] h-[28px] rounded-lg text-xs font-medium"
//                 style={getStatusStyles(item.status)}
//               >
//                 {STATUS_DISPLAY[item.status] || item.status}
//               </button>
//             </div>
//           ),
//           action: (
//             <div className="flex justify-center gap-3">
//               <EyeIcon
//                 className="cursor-pointer"
//                 onClick={() => handleViewReport(item)}
//               />
//             </div>
//           ),
//           originalData: item, // Store original data
//         }));

//         setTableData(data);
//       } else {
//         setTableData([]);
//         setTotalRecords(0);
//       }
//     } catch (error) {
//       console.error("Failed to fetch reports:", error);
//       setTableData([]);
//       setTotalRecords(0);
//     } finally {
//       setLoading(false);
//     }
//   }, [currentPage, pageSize, searchTerm]);

//   useEffect(() => {
//     fetchReports();
//   }, [fetchReports]);

//   // Handle page change
//   const handlePageChange = useCallback((page) => {
//     setCurrentPage(page);
//   }, []);

//   return (
//     <div
//       style={{
//         border: "1px solid #3BA2B959",
//         borderRadius: "10px",
//         marginTop: "15px",
//         backgroundColor: "white",
//       }}
//     >
//       <div className="flex justify-between mx-8 mt-4 font-medium">
//         <div className="flex gap-16">
//           <p className="text-[#06513D] text-base pt-2">Reports</p>
//           <SearchBar width="300px" onSearch={handleSearch} />
//         </div>
//         <div>
//           <Button
//             style={{
//               background: "#06513D",
//               height: "50px",
//               width: "150px",
//               borderRadius: "10px",
//               marginBottom: "15px",
//               color: "white",
//             }}
//             onClick={() => setGenerateReport(true)}
//           >
//             Filter
//           </Button>
//         </div>
//       </div>

//       {generateReport && (
//         <FilterReport
//           onOpen={generateReport}
//           onClose={() => setGenerateReport(false)}
//           refreshTable={fetchReports}
//         />
//       )}

//       {viewReportOpen && (
//         <ViewReport
//           onOpen={viewReportOpen}
//           onClose={() => setViewReportOpen(false)}
//           reportData={selectedReport}
//           reportId={selectedReport?._id}
//         />
//       )}

//       <Tables
//         data={tableData}
//         headers={surveyHeader}
//         currentPage={currentPage}
//         pageSize={pageSize}
//         totalRecords={totalRecords}
//         onPageChange={handlePageChange}
//         sortBy={sortBy}
//         sortOrder={sortOrder}
//         onSort={handleSort}
//         loading={loading}
//       />
//     </div>
//   );
// };

// export default React.memo(ReportTable);

import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Button } from "antd";
import { SearchBar } from "../../../../../components/Elements/Search/SearchBar";
import { Tables } from "../../../../../components/Elements/Tables/Tables";
import SortData from "../../../../../components/Elements/SortData.js/SortData";
import { ReactComponent as EyeIcon } from "../../../../../assets/svgs/eye-icon.svg";
import FilterReport from "../DailogBoxes/FilterReport";
import ViewReport from "../DailogBoxes/ViewReport";
import { getApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";
import { useLocation } from "react-router-dom";

const ReportTable = ({ projectId, clientId }) => {
  const [tableData, setTableData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [generateReport, setGenerateReport] = useState(false);
  const [viewReportOpen, setViewReportOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [totalRecords, setTotalRecords] = useState(0);

  const surveyHeader = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Name", key: "name" },
      { label: "Requested Date", key: "requested_date" },
      { label: "Status", key: "status" },
      { label: "Action", key: "action" },
    ],
    [],
  );

  const STATUS_DISPLAY = {
    in_process: "In Process",
    completed: "Completed",
    rejected: "Rejected",
  };

  const getStatusStyles = (status) => {
    switch (status) {
      case "in_process":
        return {
          backgroundColor: "#45827659",
          color: "#000000",
          border: "1px solid #06513D",
        };
      case "completed":
        return {
          backgroundColor: "#E8C45859",
          color: "#000000",
          border: "1px solid #E8C458",
        };
      case "rejected":
        return {
          backgroundColor: "#6AA4F759",
          color: "#000000",
          border: "1px solid #6AA4F7",
        };
      default:
        return {
          backgroundColor: "#F3F4F6",
          color: "#374151",
          border: "1px solid #374151",
        };
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1); // Reset to page 1 on search
  };

  const handleSort = (key, order) => {
    setSortBy(key);
    setSortOrder(order);
    setTableData((prevData) => SortData({ data: prevData, key, order }));
  };

  const handleViewReport = (item) => {
    setSelectedReport(item);
    setViewReportOpen(true);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return `${String(date.getDate()).padStart(2, "0")}-${String(
      date.getMonth() + 1,
    ).padStart(2, "0")}-${date.getFullYear()}`;
  };

  const fetchReports = async () => {
    setLoading(true);
    try {
      const finalClientId =
        typeof clientId === "object" ? clientId?._id : clientId;
      console.log(finalClientId, "clientIdclientId");
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_REPORTS(
          currentPage,
          pageSize,
          searchTerm,
          projectId,
          finalClientId,
        ),
      });

      console.log("API Response:", response);

      if (response?.success && response?.data) {
        // Set pagination data
        if (response.pagination) {
          setTotalRecords(response.pagination.totalRecords);
        }

        // Map table data
        const mappedData = response.data.map((item, index) => ({
          key: item._id,
          serial: (
            <div className="text-center">
              {(currentPage - 1) * pageSize + index + 1}
            </div>
          ),
          name: <div className="text-center">{item.report?.name || "N/A"}</div>,
          requested_date: (
            <div className="text-center">{formatDate(item.requested_on)}</div>
          ),
          status: (
            <div className="flex justify-center">
              <button
                className="w-[100px] h-[28px] rounded-lg text-xs font-medium"
                style={getStatusStyles(item.status)}
              >
                {STATUS_DISPLAY[item.status] || item.status}
              </button>
            </div>
          ),
          action: (
            <div className="flex justify-center gap-3">
              <EyeIcon
                className="cursor-pointer"
                onClick={() => handleViewReport(item)}
              />
            </div>
          ),
          originalData: item,
        }));

        setTableData(mappedData);
      } else {
        setTableData([]);
        setTotalRecords(0);
      }
    } catch (error) {
      console.error("Failed to fetch reports:", error);
      setTableData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, [currentPage, searchTerm]);

  // Page change handler
  const handlePageChange = (page) => {
    console.log("Page changed to:", page);
    setCurrentPage(page);
  };

  return (
    <div
      style={{
        border: "1px solid #3BA2B959",
        borderRadius: "10px",
        marginTop: "15px",
        backgroundColor: "white",
      }}
    >
      <div className="flex justify-between mx-8 mt-4 font-medium">
        <div className="flex gap-16">
          <p className="text-[#06513D] text-base pt-2">Reports</p>
          <SearchBar width="300px" onSearch={handleSearch} />
        </div>
        <div>
          <Button
            style={{
              background: "#06513D",
              height: "50px",
              width: "150px",
              borderRadius: "10px",
              marginBottom: "15px",
              color: "white",
            }}
            className="hover:!bg-[#387464] hover:!border-[#06513D]"
            onClick={() => setGenerateReport(true)}
          >
            Filter
          </Button>
        </div>
      </div>

      {generateReport && (
        <FilterReport
          onOpen={generateReport}
          onClose={() => setGenerateReport(false)}
          refreshTable={fetchReports}
        />
      )}

      {viewReportOpen && (
        <ViewReport
          onOpen={viewReportOpen}
          onClose={() => setViewReportOpen(false)}
          reportData={selectedReport}
          reportId={selectedReport?._id}
        />
      )}

      {/* ✅ FIXED: Pass correct prop names that Tables component expects */}
      <Tables
        data={tableData}
        headers={surveyHeader}
        current={currentPage} // ✅ Changed from currentPage
        pageSize={pageSize}
        total={totalRecords} // ✅ Changed from totalRecords
        onChange={handlePageChange} // ✅ Changed from onPageChange
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSort={handleSort}
        loading={loading}
      />
    </div>
  );
};

export default React.memo(ReportTable);
